import React from 'react';
import { Box, Button } from '@material-ui/core';

import { useStyles } from './integrationAppCard.styles';

function IntegrationAppCard({ app, description, url, icon, initials, type }) {
    const classes = useStyles();

    function renderIcon() {
        if (icon) {
            return (
                <img
                    src={icon}
                    alt={app}
                    className={classes.iconImage}
                />
            );
        }
        return (
            <span className={classes.iconInitials}>{initials}</span>
        );
    }

    return (
        <Box className={classes.card}>
            <Box>
                <Box className={classes.cardTop}>
                    <Box className={classes.iconContainer}>
                        {renderIcon()}
                    </Box>
                    <span className={classes.typeLabel}>{type}</span>
                </Box>
                <div className={classes.appName}>{app}</div>
                <div className={classes.description}>{description}</div>
            </Box>
            <Button
                className={classes.viewButton}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                disableRipple
            >
                VIEW
            </Button>
        </Box>
    );
}

export default IntegrationAppCard;
